import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { api } from '../../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await api.requestPasswordReset(email.trim());
      setSent(true);
    } catch {
      setError('Det lykkedes ikke. Prøv igen om lidt.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 360, width: '100%' }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <LocalShippingIcon color="primary" sx={{ fontSize: 36 }} />
            <Typography variant="h6" fontWeight={700} sx={{ mt: 0.5 }}>
              DORA Insight
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Nulstil adgangskode
            </Typography>
          </Box>

          {sent ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              Hvis {email.trim()} hører til en bruger, er der sendt en mail med et link.
            </Alert>
          ) : (
            <>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  margin="dense"
                  required
                  autoFocus
                  autoComplete="email"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={isLoading}
                  sx={{ mt: 2 }}
                >
                  {isLoading ? <CircularProgress size={20} /> : 'Send link'}
                </Button>
              </form>
            </>
          )}

          <Button component={Link} to="/login" fullWidth sx={{ mt: 1 }}>
            Tilbage til login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
